/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { typeAheadListMessages as messages } from '@atlaskit/editor-common/type-ahead';
import { EmptyState } from './EmptyState';
import { GenericErrorSVG } from './GenericErrorSVG';
var minHeightComponentStyles = css({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'center',
  minHeight: '290px'
});
export var TypeAheadErrorFallback = function TypeAheadErrorFallback() {
  var intl = useIntl();
  var header = intl.formatMessage(messages.typeAheadErrorFallbackHeading);
  var description = intl.formatMessage(messages.typeAheadErrorFallbackDesc);
  return jsx("div", {
    "data-testid": "typeahead-error-boundary-ui",
    css: minHeightComponentStyles
  }, jsx(EmptyState, {
    header: header,
    renderImage: function renderImage() {
      return jsx(GenericErrorSVG, null);
    },
    description: description
  }));
};